import { imageExtensions } from "../../../config";
import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";
import _ from "lodash";
import i18n from "../../../functions/i18next";

export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    optionButtons: {
      type: Object,
      default: () => {},
    },
    checkboxId: String,
    mySpace: {
      type: Number,
      default: 0,
    },
    folderInfo: Object,
    doneSearching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: this.$options.name,
      allChecked: false,
      sortData: {
        sortKey: "name",
        isAsc: true,
      },
      selectedFiles: [],
      selectedFolders: [],
      layout: "list",
      topOptionsName: i18n.tc("common.file", 1),
      folderId: this.$route.params.id,
      totalFileSize: "",
      fileId: this.$route.params.file,
      fileEditOptions: [],
      emptyContent: false,
    };
  },
  created() {
    this.openFileDetail();
    this.setFileEditOptions();
    this.setEmptyContent();

    //set upload fodler info if present

    EventBus.$on(`${this.id}-select-all`, (data) => {
      this.allChecked = data.checked;
      this.updatedAllSelected(data.checked);
    });

    EventBus.$on(`sort-option-update`, (data) => {
      this.sortData = {
        sortKey: data.sortKey,
        isAsc: data.isAsc,
      };
    });

    EventBus.$on(`view-option-update`, (data) => {
      this.layout = data.label;
    });

    //update label of top options based on file or folder
    EventBus.$on(`top-options-show`, (data) => {
      if (data.id === "edit-files") {
        this.topOptionsName = data.extension
          ? i18n.tc("common.file", 1)
          : i18n.tc("common.folder", 1);
      }
    });
  },
  methods: {
    checkIfFolderSelected() {
      return this.selectedFolders.length > 0;
    },
    setFileEditOptions() {
      this.fileEditOptions = [
        {
          id: "rename-file",
          label: `${i18n.t("common.rename")} ${this.topOptionsName}`,
          type: "emitter",
          icon: "edit",
          emitterName: "rename-file-show",
          emitterData: { id: "rename-file" },
          rights: ["rename_files", "rename_folders"],
        },
        {
          id: "move-file",
          label: `${i18n.t("common.move")} ${this.topOptionsName}`,
          type: "emitter",
          icon: "move",
          emitterName: "move-file-show",
          emitterData: { id: "move-file" },
          rights: ["move_files", "move_folders"],
        },

        {
          id: "delete-file",
          label: `${i18n.t("common.delete")} ${this.topOptionsName}`,
          type: "emitter",
          icon: "delete--alt",
          emitterName: "delete-file-show",
          emitterData: { id: "delete-file" },
          rights: ["delete_files", "delete_folders"],
        },
      ];

      if (!this.checkIfFolderSelected()) {
        //no folders so add tags

        this.fileEditOptions = [
          ...this.fileEditOptions,
          {
            id: "mobile-tags",
            label: i18n.tc("common.tag", 2),
            type: "emitter",
            icon: "tag",
            emitterName: "mobile-tags-show",
            emitterData: { id: "mobile-tags" },
            rights: ["delete_tags"],
          },
        ];
      }
    },
    checkHasFileOptions() {
      let hasAnyRights = false;
      this.fileEditOptions.forEach((option) => {
        if (option.rights) {
          if (userHasAllRights(option.rights, this)) {
            hasAnyRights = true;
          }
        }
      });

      return hasAnyRights;
    },
    openFileDetail() {
      if (this.files.length && this.$route.params.file) {
        //has files and ad file id
        //get file data
        const fileData = this.files.filter(
          (file) => file.id === this.$route.params.file
        )[0];

        //emit open detail
        EventBus.$emit("openOverlayPage", {
          id: "file-detail",
          file: fileData,
        });
      }
    },

    selectUploadFolder() {
      if (this.folderInfo) {
        this.$store.state.uploadFolderInfo = this.folderInfo;

        this.$store.state.isUploadingMobile = false;

        //go to upload
        this.$router.push(`/${this.$store.state.company}/upload`);
      }
    },
    updateSelected(items = []) {
      const newSelectedFiles = [];
      const newSelectedFolders = [];

      items.forEach((item) => {
        if (item.extension) {
          newSelectedFiles.push(item);

          //add to total

          //totalFileSize
        } else {
          newSelectedFolders.push(item);
        }
      });

      this.selectedFiles = newSelectedFiles;
      this.selectedFolders = newSelectedFolders;

      this.toggleOptionButtons();
    },

    updatedAllSelected(checked) {
      if (checked) {
        this.updateSelected(this.files);
      } else {
        this.updateSelected();
      }
    },
    filePresent(value, arrayName) {
      return this[arrayName].indexOf(value) !== -1;
    },
    handleChecks(e) {
      const checkbox = e.currentTarget;

      const id = checkbox.dataset.id;
      const arrayName = checkbox.dataset.arrayname;

      if (checkbox.checked) {
        //add to the slected files if not present
        this.addToSelected(id, arrayName);
      } else {
        //remove from selected files if present
        this.removeFromSelected(id, arrayName);
      }

      //open or close option buttons
      this.toggleOptionButtons();
    },
    addToSelected(item, arrayName) {
      if (!this.filePresent(item, arrayName)) {
        const newItems = this[arrayName];

        //add to this instance
        newItems.push(item);

        //add to transfer selected
        if (this.$store.state.isTransfering) {
          const newTransferItems = this.$store.state.transferItems;

          if (!newTransferItems[arrayName].includes(item)) {
            //add to the list
            newTransferItems[arrayName].push(item);

            this.$store.state.transferItems = newTransferItems;
          }
        }

        this[arrayName] = newItems;
      }
    },
    removeFromSelected(item, arrayName) {
      const newItems = this[arrayName];

      newItems.splice(newItems.indexOf(item), 1);

      //add to transfer selected
      if (this.$store.state.isTransfering) {
        const newTransferItems = this.$store.state.transferItems;

        //add to the list
        newTransferItems[arrayName].splice(
          newTransferItems[arrayName].indexOf(item),
          1
        );

        this.$store.state.transferItems = newTransferItems;
      }

      this[arrayName] = newItems;
    },
    toggleOptionButtons() {
      EventBus.$emit(`option-buttons-show`, {
        show: this.selectedFiles.length > 0 || this.selectedFolders.length > 0,
      });

      EventBus.$emit(`${this.id}-update`, {
        selectedFiles: this.selectedFiles,
        selectedFolders: this.selectedFolders,
      });
    },
    transferSelected() {
      //got to the url
      this.$router.push(`/${this.$store.state.company}/mobile-transfer/ready`);
    },
    setEmptyContent() {
      if (this.folderInfo) {
        if (!this.folderInfo.parent_id) {
          //has no parent set so parent is a space

          if (this.mySpace) {
            //is my space
            this.emptyContent = {
              title: i18n.t("files.empty_myspace_title"),
              text: i18n.t("files.empty_myspace_text"),
              icon: "empty-space",
            };
          } else {
            //is other space
            this.emptyContent = {
              title: i18n.t("spaces.empty_title"),
              text: i18n.t("spaces.empty_text"),
              icon: "empty-folder",
            };
          }
        }
      } else {
        this.emptyContent = {
          title: i18n.t("spaces.empty_title"),
          text: i18n.t("spaces.empty_text"),
          icon: "empty-folder",
        };
      }
    },
  },
  computed: {
    filteredOptionBtns() {
      let btns = this.optionButtons;

      if (this.checkIfFolderSelected()) {
        btns = {
          buttons: this.optionButtons.buttons.filter((btn) => !btn.noFolder),
        };
      }

      return btns;
    },
    selectedTitle() {
      const count = this.selectedFiles.length + this.selectedFolders.length;
      return `${count} ${count > 1 ? "items" : "item"} selected`;
    },
    selectedTransferingTitle() {
      const selectedItems = this.$store.state.transferItems;
      const count =
        selectedItems.selectedFiles.length +
        selectedItems.selectedFolders.length;
      return `${count} ${count > 1 ? "items" : "item"} selected`;
    },
    uploadTitle() {
      return `Currently in <span class="label--tiny-black">${
        this.folderInfo
          ? this.folderInfo.name
            ? this.folderInfo.name
            : ""
          : ""
      }</span>`;
    },
    adjustedFiles() {
      const items = this.files.map((file) => {
        return {
          ...file,
          checked: this.allChecked,
          inputFunc: this.handleChecks,
        };
      });

      if (this.layout !== "masonry") {
        return _.orderBy(
          items,
          this.sortData.sortKey,
          this.sortData.isAsc ? "asc" : "desc"
        );
      } else {
        const images = [];
        const other = [];

        items.forEach((item) => {
          let result = false;

          imageExtensions.forEach((ext) => {
            if (item.extension === ext) {
              result = true;
            }
          });

          if (result) {
            //add to images array
            images.push(item);
          } else {
            //add to other array
            other.push(item);
          }
        });

        return [
          ..._.orderBy(
            images,
            this.sortData.sortKey,
            this.sortData.isAsc ? "asc" : "desc"
          ),
          ..._.orderBy(
            other,
            this.sortData.sortKey,
            this.sortData.isAsc ? "asc" : "desc"
          ),
        ];
      }
    },
  },
  watch: {
    files() {
      this.updateSelected();
      this.openFileDetail();
    },
  },
};
